var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgJobs = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Job_Blue",
    "data-name": "Job Blue"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_work_24px",
    d: "M41.6,10.729H32.8V6.364A4.367,4.367,0,0,0,28.4,2H19.6a4.367,4.367,0,0,0-4.4,4.364v4.364H6.4a4.348,4.348,0,0,0-4.378,4.364L2,39.1a4.367,4.367,0,0,0,4.4,4.364H41.6A4.367,4.367,0,0,0,46,39.1v-24A4.367,4.367,0,0,0,41.6,10.729Zm-13.2,0H19.6V6.364h8.8Z",
    transform: "translate(-2 -1.269)",
    fill: "#09819a"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJobs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Jobs.0501f4d0.svg";
export { ForwardRef as ReactComponent };